<template>
    <v-container v-if="0 !== results.length" id="result">
        <h1>Recommended Application Profile</h1>
        <v-row>
            <v-col cols="12" lg="6">
                <v-card class="scores mb-2">
                    <v-card-title>Scores</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <div class="display-4 text-center">
                                    <span class="final-score">
                                        {{ finalScore }}
                                    </span>
                                </div>
                                <div class="headline text-center">
                                    Level
                                    {{ results.level }}
                                </div>
                            </v-col>
                            <v-col cols="12" sm="8" class="mt-2">
                                Your MedSchoolCoach applicant score takes into
                                account your statistics, specifically your GPA
                                and MCAT, as well as your extracurricular
                                activities. It is also adjusted for your
                                ethnicity and other factors such as GPA trend
                                and your undergrad's prestige. It is NOT meant
                                to be a comprehensive assessment of your
                                chances, however, is meant to stratify you into
                                categories to better select an appropriate
                                school list. Note, the majority of applicants
                                will fall into Level 5 or 6
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" lg="6">
                <v-card class="recommendations">
                    <v-card-title>Recommendations</v-card-title>
                    <v-card-text>
                        <v-list dense class="ml-0 pl-0 recommendations-list">
                            <v-list-item
                                v-for="result in getRegularTiers(
                                    this.results.results
                                )"
                                :key="result.school_type"
                                class="pl-0"
                            >
                                <strong class="mr-1">
                                    {{ result.school_type }}:
                                </strong>
                                {{
                                    recommendation(
                                        result.percent,
                                        result.school_type
                                    )
                                }}
                            </v-list-item>
                            <v-list-item class="pl-0">
                                <strong class="mr-1">Osteopathic:</strong>
                                {{ osteopathicRecommendation }}
                            </v-list-item>
                            <v-list-item class="pl-0">
                                <strong class="mr-1">International:</strong>
                                {{ internationalRecommendation }}
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="schools">
            <v-card-title>Your Selections</v-card-title>
            <v-card-text>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Tier</th>
                                <th class="text-left d-none d-sm-block">
                                    Recommended
                                </th>
                                <th class="text-left">Remaining</th>
                                <th class="text-left">Selected</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>In-State</td>
                                <td>-</td>
                                <td>-</td>
                                <td>{{ getInStateSelectedCount() }}</td>
                            </tr>
                            <tr
                                v-for="tier in results.results"
                                :key="tier.school_type"
                            >
                                <td>{{ tier.school_type }}</td>
                                <td>
                                    {{
                                        getTierRecommendationNumber(
                                            tier.percent,
                                            tier.school_type
                                        )
                                    }}
                                </td>
                                <td>
                                    {{
                                        getTierRemaining(
                                            tier.school_type,
                                            tier.percent
                                        )
                                    }}
                                </td>
                                <td>
                                    {{
                                        getSelectedByTier(tier.school_type)
                                            .length
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>

        <v-card class="schools">
            <v-card-title>
                Schools
                <v-spacer></v-spacer>
                <v-btn
                    v-if="0 < this.$store.getters.selectedSchools.length"
                    to="/my-schools"
                    color="white"
                    text
                >
                    <v-icon class="mr-1">mdi-school</v-icon>
                    <span>My Schools</span>

                    <v-chip color="white" class="ml-2">
                        {{ this.$store.getters.selectedSchools.length }}
                    </v-chip>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <result-tabs :results="this.results"></result-tabs>
            </v-card-text>
        </v-card>
        <v-btn
            v-if="0 < this.$store.getters.selectedSchools.length"
            to="/my-schools"
            id="my-schools-btn-mobile"
            color="primary"
            text
        >
            <v-icon class="-2 mr-2 mt-n1" size="16">mdi-plus</v-icon>
            <span class="d-none d-md-block">My Schools</span>

            <v-chip color="primary" class="ml-2">
                {{ this.$store.getters.selectedSchools.length }}
            </v-chip>
        </v-btn>
    </v-container>
</template>

<script>
import scoreService from '../services/ScoreService';
import resultsService from '../services/ResultsService';
import ResultTabs from '../components/ResultTabs';
import OsteopathicService from '../services/OsteopathicService';
import InternationalService from '../services/InternationalService';

export default {
    name: 'Result',
    data: () => ({
        finalScore: 0,
        list: [],
        results: {},
        nonDOSchools: null,
    }),
    components: {
        ResultTabs,
    },
    created() {
        if (
            !window.sessionStorage.getItem('user') ||
            !window.sessionStorage.getItem('answer')
        ) {
            this.$router.push('/');
        }

        this.$store.dispatch('loadFromSession');

        const answers = this.$store.getters.answers;
        this.finalScore = scoreService.getFinalScore(
            answers,
            this.$store.getters.user.gpaScore,
            this.$store.getters.user.mcatScore
        );

        this.results = resultsService.getLevel(this.finalScore);
        this.nonDOSchools =
            this.results.total_schools - this.results.total_do_school;

        this.$store.commit('setFinalScore', this.finalScore);
        this.$store.commit('setLevel', this.results.level);
    },
    methods: {
        getTierRemaining(tier, percent) {
            if ('Osteopathic' === tier) {
                return (
                    this.osteopathicNumber - this.getSelectedByTier(tier).length
                );
            }

            if ('International' === tier) {
                return '-';
            }

            const state = this.$store.getters.user.state;
            const expected = this.getNumberFromPercent(percent);
            const added = this.getSelectedByTier(tier);
            let countable = 0;

            for (let i = 0; i < added.length; i++) {
                if (state !== added[i].state) {
                    countable++;
                }
            }

            return expected - countable;
        },

        getRegularTiers(list) {
            return list.filter(item => {
                return (
                    item.school_type !== 'Osteopathic' &&
                    item.school_type !== 'International'
                );
            });
        },

        getSelectedByTier(tier) {
            return this.$store.getters.selectedSchools.filter(selected => {
                return selected.level === tier;
            });
        },

        getInStateSelectedCount() {
            const state = this.$store.getters.user.state;
            return this.$store.getters.selectedSchools.filter(selected => {
                return selected.state === state;
            }).length;
        },

        getTierRecommendationNumber(percent, tier) {
            if ('Osteopathic' === tier) {
                return this.osteopathicNumber;
            }

            if ('International' === tier) {
                return '-';
            }

            return this.getNumberFromPercent(percent);
        },

        getNumberFromPercent(percent) {
            return Math.round((this.nonDOSchools * percent) / 100);
        },

        recommendation(percent, tier) {
            const number = Math.round(this.getNumberFromPercent(percent));

            if (number > 0) {
                return `Consider applying to about ${number} ${tier} Schools`;
            }

            return 'Schools are likely out of range';
        },
    },

    computed: {
        osteopathicRecommendation() {
            return OsteopathicService.getRecommendation(this.finalScore);
        },

        osteopathicNumber() {
            return OsteopathicService.getNumber(this.finalScore);
        },

        internationalRecommendation() {
            return InternationalService.getRecommendation(this.finalScore);
        },
    },
};
</script>
<style lang="scss" scoped>
#my-schools-btn-mobile {
    position: fixed;
    bottom: 20px;
    right: 5px;
    background: #183f64;
    color: white;
    padding: 0 10px;
    border-radius: 10%;
    height: 40px;

    i,
    .v-icon {
        color: white;
        margin: 0 !important;
    }

    .v-chip {
        padding: 0;
        margin: 0;
    }

    @media (min-width: 1201px) {
        display: none;
    }
}

.recommendations {
    h2 {
        color: rgba(0, 0, 0, 0.87) !important;
    }

    .v-list-item {
        min-height: 26px;
    }
}

.v-card {
    &__title {
        color: white;
    }

    &.scores {
        .v-card__title {
            background: #22598d;
        }
    }

    &.recommendations {
        .v-card__title {
            background: #0f9732;
        }
    }

    &.schools {
        .v-card__title {
            background: #183f64;
        }
    }
}

.final-score {
    white-space: nowrap;
}
</style>
<style lang="scss">
div.v-tab:nth-child(7),
div.v-tab:nth-child(8) {
    background: lighten(#183f64, 65%);
}

div.v-tab:nth-child(7) {
    border-right: 1px solid lighten(#183f64, 50%);
}

#result * {
    user-select: none;
}
</style>
